import React, {Component} from "react";
import { Modal, Button, Toast } from "antd-mobile";
import WxApi from "../common/wxapi";
import EnrollServers from "../services/EnrollServers";
import right_arrow from '../res/img/right_arrow.png';
import { inject, observer } from 'mobx-react';

// 无权限角色对应的提示文案（对齐小程序 utils/util.js checkAdminRole）
const ADMIN_ROLE_NAMES = {
    1: '查看/导出数据',
    2: '核销/签到',
    3: '编辑活动/发送通知',
    4: '编辑信息/审核/删除退款',
};

@inject("enrollStore")
@observer
class ManageDialog extends Component{
    state = {
        showManage: false,
    };
    constructor(props){
        super(props);
    };
    componentWillReceiveProps(props){
        this.setState({showManage: props.showManage});
    }
    // 对齐小程序 utils/util.js checkAdminRole：
    // 拥有对应角色编号（admins_node 含 role）或 is_owner/sup_vip 放行；
    // 无权限时弹窗提示并可跳转权限页查看。
    checkAdminRole = (role) => {
        let {detail} = this.props.enrollStore;
        let admins_node = detail.admins_node || [];
        let ownerGod = detail.is_owner || detail.sup_vip;
        if(ownerGod || admins_node.indexOf(role) > -1){
            return true;
        }
        Modal.alert('无操作权限', `你暂无「${ADMIN_ROLE_NAMES[role] || '该'}」权限，如需操作请联系发起人添加权限`, [
            { text: '我知道了', style: 'default' },
            { text: '查看权限', onPress: () => {
                this.props.close && this.props.close();
                // 对齐小程序 checkAdminRole：查看权限跳 adminRole 独立页（自己的权限+退出管理员），
                // 未接入 openAdminRole 时退回原 openAdmin 行为
                if(this.props.openAdminRole){
                    this.props.openAdminRole();
                }else if(this.props.openAdmin){
                    this.props.openAdmin();
                }
            }},
        ]);
        return false;
    }
    // 截止/开启活动：对齐小程序 components/manage/manage.js endEnroll
    // 先做 checkAdminRole(3) 校验；status==1（进行中）时二次确认后调用 close_enroll；
    // status!=1 时端内提示需修改报名时间，确认后引导去小程序编辑页
    endEnroll = (e) => {
        e.stopPropagation();
        if(!this.checkAdminRole(3)){
            return;
        }
        let {detail} = this.props.enrollStore;
        if(Number(detail.status) !== 1){
            // 开启活动：对齐小程序「温馨提示：请修改报名开始或报名截止时间并保存」，
            // H5 无法直接编辑，确认后打开小程序入口（二维码面板）
            Modal.alert('温馨提示', '请修改报名开始或报名截止时间并保存', [
                { text: '取消', style: 'default' },
                { text: '去修改', onPress: () => {
                    this.props.open && this.props.open();
                }},
            ]);
            return;
        }
        Modal.alert('确认活动提前截止', '活动提前截止后，其他人将无法参与此活动。', [
            {text: '取消'},
            {text: '确定', onPress: () => {
                Toast.loading('正在提交数据', 0);
                EnrollServers.openOrCloseEnroll(2, detail.eid).then((d) => {
                    Toast.hide();
                    let data = d && d.data;
                    if(data && data.sta == 0){
                        Toast.success('活动已截止', 1);
                        this.props.close && this.props.close();
                        this.props.refresh && this.props.refresh();
                    }else if(data && data.sta == -500){
                        // 登录态失效，拦截器已清 token，引导重新授权
                        React.$wx && React.$wx.webLogin && React.$wx.webLogin();
                    }else{
                        Toast.fail((data && data.msg) || '操作失败');
                    }
                }).catch(() => {
                    Toast.hide();
                    Toast.fail('操作失败');
                });
            }},
        ]);
    }
    // 未改造项（编辑修改/复制创建/收款记账/会员管理/数据面板）的微信内拉起层：
    // 微信移动端渲染透明 wx-open-launch-weapp，点击直接拉起小程序；
    // 非微信不渲染，点击冒泡到 ul 走 open() 弹二维码面板引导去小程序。
    // 注意只做单项级覆盖，不能整幅盖住 menu-list，否则会吞掉已改造项的 H5 onClick。
    renderMiniCover = () => {
        if(!(WxApi.isWeixn() && WxApi.isMobile())){
            return null;
        }
        let {detail} = this.props.enrollStore;
        const coverStyle = {
            position: 'absolute',
            left: '0',
            top: '0',
            width: '100%',
            height: '100%',
        };
        return (
            <div className="btn-open-mini-opacity" style={coverStyle}>
                <wx-open-launch-weapp
                        style={coverStyle}
                        id="launch-btn"
                        username="gh_ae6449501a82"
                        path={detail.eid ? this.props.wxJumpPath : '/pages/default/default.html'}
                    >
                    <script type="text/wxtag-template">
                        <div style={coverStyle}></div>
                    </script>
                </wx-open-launch-weapp>
            </div>
        );
    }
    render(){
        let {detail} = this.props.enrollStore;		
        const miniBtnStyle = {
			position: 'absolute',
			left: '0',
			top: '0',
			width: '100%',
			height: '100%',
		}
        return (
            <Modal visible={this.state.showManage} transparent={true} animationType="slide-up" popup className="manage-menu-dialog" onClose={()=>{
                this.props.close()          
            }}>
                <div className='manage-header' onClick={()=>{
                    window.open('http://baominggongju.com')
                }}>
                    <img className='web-img' src='https://cdn-xcxcustom.weiyoubot.cn/20210608/542f165ee3f7fe3ff27f215d3b951e03.png'></img>
                    <div className='header-main'>
                        <span className='warn-tips'>电脑端创建编辑更方便</span>
                        <a className='web-url' target='_blank' href='http://baominggongju.com'>https://baominggongju.com</a>
                    </div>
                    <Button className='operate-btn'>去试试</Button>
                </div>
                <div className="menu-operate" style={{position: 'relative'}}>
                    <span>活动管理</span>
                    <div className="right-more" onClick={()=>{
                        this.props.open();         
                    }}>
                        <span>更多</span> 
                        <img className="icon-right" src={right_arrow} />
                        {
                            WxApi.isWeixn() && WxApi.isMobile() ? <div className="btn-open-mini-opacity">
                                <wx-open-launch-weapp
                                        style={miniBtnStyle}
                                        id="launch-btn"
                                        username="gh_ae6449501a82"
                                        path={detail.eid ? this.props.wxJumpPath : '/pages/default/default.html'}
                                    >
                                    <script type="text/wxtag-template">
                                        <div style={miniBtnStyle}></div>
                                    </script>
                                </wx-open-launch-weapp>
                            </div> : null
                        }	
                    </div>
                </div>
                <ul className='menu-list' style={{position: 'relative'}} onClick={()=>{
                    this.props.open();
                }}>
                    {
                        // 菜单显隐整体对齐小程序 components/manage/manage.wxml；
                        // 需要角色校验的项（导出数据/核销签到/截止活动）在点击时走 checkAdminRole。
                        // 跳转规则：已改造项（导出数据/删除/发送通知/核销签到/设置管理员/截止开启活动）
                        // 走 H5 onClick；未改造项（编辑修改/复制创建/收款记账/会员管理）微信内经
                        // renderMiniCover 直接拉起小程序，非微信冒泡到 ul 走 open() 弹二维码面板。
                        <li className='menu-items' style={{position: 'relative'}}>
                            <img className='menu-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/20220516/02ec2cab65ec0856e06ebde7aa271c23.png'></img>
                            <span>编辑修改</span>
                            {this.renderMiniCover()}
                        </li>
                    }
                    {
                        <li className='menu-items' style={{position: 'relative'}}>
                            <img className='menu-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/20220516/649c3c52576527291ccd447033354057.png'></img>
                            <span>复制创建</span>
                            {this.renderMiniCover()}
                        </li>
                    }
                    <li className='menu-items' onClick={(e)=>{
                        // 导出数据跳转H5导出页面，不再弹小程序二维码；权限对齐小程序 checkAdminRole(1)；
                        // 调用方未接 H5 能力时不拦截，冒泡到 ul 引导去小程序
                        if(!this.props.exportData){
                            return;
                        }
                        e.stopPropagation();
                        if(!this.checkAdminRole(1)){
                            return;
                        }
                        this.props.exportData();
                    }}>
                        <img className='menu-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-11-07/972ee3b5be908e4a96400dc3a7f6a0dc.png'></img>
                        <span>导出数据</span>
                    </li>
                    {
                        detail.is_owner || detail.sup_vip ?
                        <li className='menu-items' onClick={(e)=>{
                            // 删除活动走H5删除确认弹窗，不再弹小程序二维码；未接入时冒泡到 ul 引导去小程序
                            if(!this.props.deleteEnroll){
                                return;
                            }
                            e.stopPropagation();
                            this.props.deleteEnroll();
                        }}>
                            <img className='menu-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/20220516/010ceb70622e5501c077e3315ff19754.png'></img>
                            <span>删除</span>
                        </li> : null
                    }
                    {
                        <li className='menu-items' onClick={(e)=>{
                            // 发送通知跳转H5通知列表页，不再弹小程序二维码；未接入时冒泡到 ul 引导去小程序
                            if(!this.props.sendNotice){
                                return;
                            }
                            e.stopPropagation();
                            this.props.sendNotice();
                        }}>
                            <img className='menu-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/20220516/e7504a632122578777f4863a280a8fdb.png'></img>
                            <span>发送通知</span>
                        </li>
                    }
                    {
                        <li className='menu-items' style={{position: 'relative'}}>
                            <img className='menu-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/20220516/01e879b71eb8b8a94c1e87f6c42ac45c.png'></img>
                            <span>收款记账</span>
                            {this.renderMiniCover()}
                        </li>
                    }
                    {
                        // 对齐小程序：有管理权限（admins_node 非空）显示「管理员权限」，
                        // 点击跳转独立权限页（对应小程序 subpackage/admin/adminRole），不进管理员列表
                        detail.admins_node && detail.admins_node.length ?
                        <li className='menu-items' onClick={(e)=>{
                            // 未接入时冒泡到 ul 引导去小程序
                            if(!this.props.openAdminRole){
                                return;
                            }
                            e.stopPropagation();
                            this.props.openAdminRole();
                        }}>
                            <img className='menu-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/20220516/b4b6398cb18c4993656a44fef36f3927.png'></img>
                            <span>管理员权限</span>
                        </li>
                        :
                        (detail.is_owner || detail.sup_vip ?
                        <li className='menu-items' onClick={(e)=>{
                            // 未接入时冒泡到 ul 引导去小程序
                            if(!this.props.openAdmin){
                                return;
                            }
                            e.stopPropagation();
                            this.props.openAdmin();
                        }}>
                            <img className='menu-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/20220516/7bf04ae8df44cc64ac1420f2a9db69f4.png'></img>
                            <span>设置管理员</span>
                        </li> : null)
                    }
                    <li className='menu-items' onClick={(e)=>{
                        // 核销签到跳转 H5 独立页面（对齐小程序 subpackage/checkin/checkin）；权限对齐小程序 checkAdminRole(2)；
                        // 未接入时冒泡到 ul 引导去小程序
                        if(!this.props.toCheckin){
                            return;
                        }
                        e.stopPropagation();
                        if(!this.checkAdminRole(2)){
                            return;
                        }
                        this.props.toCheckin();
                    }}>
                        <img className='menu-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/20220516/8447b567215cbe1396fe992bdfffb27b.png'></img>
                        <span>核销签到</span>
                    </li>
                    {
                        // 截止/开启活动：显示无条件（对齐小程序），权限在 endEnroll 内做 checkAdminRole(3)
                        <li className='menu-items' onClick={this.endEnroll}>
                            <img className='menu-img' src={detail.status == 1 ? 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220516/bf5787477274cd334a1463ebcf151ecb.png' : 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220516/02865f2a3dbd777ba63bb7072daa0973.png'}></img>
                            <span>{detail.status == 1 ? '截止活动' : '开启活动'}</span>
                        </li>
                    }
                    {
                        detail.is_owner || detail.sup_vip ?
                        <li className='menu-items' style={{position: 'relative'}}>
                            <img className='menu-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/20220516/3d1cde1ae018d8afe522827618ee17ba.png'></img>
                            <span>会员管理</span>
                            {this.renderMiniCover()}
                        </li> : null
                    }
                </ul>
                <div className="menu-operate">
                    <span>数据面板</span>
                    <div className="right-more" style={{position: 'relative'}} onClick={()=>{
                        this.props.open();         
                    }}>
                        <span>更多</span> 
                        <img className="icon-right" src={right_arrow} />
                        {
                            WxApi.isWeixn() && WxApi.isMobile() ? <div className="btn-open-mini-opacity">
                                <wx-open-launch-weapp
                                        style={miniBtnStyle}
                                        id="launch-btn"
                                        username="gh_ae6449501a82"
                                        path={detail.eid ? this.props.wxJumpPath : '/pages/default/default.html'}
                                    >
                                    <script type="text/wxtag-template">
                                        <div style={miniBtnStyle}></div>
                                    </script>
                                </wx-open-launch-weapp>
                            </div> : null
                        }	
                    </div>
                </div>
                <ul className="data-list" style={{position: 'relative'}} onClick={()=>{
                    this.props.open();         
                }}>
                    <li className="data-items">
                        <span className="cen-num">{detail.count}</span>
                        <span>提交 ></span>
                    </li>
                    <li className="data-items">
                        <span className="cen-num">{detail.total_referer}</span>
                        <span>分享 ></span>
                    </li>
                    <li className="data-items">
                        <span className="cen-num">{detail.help_apply_total}</span>
                        <span>求名额 ></span>
                    </li>
                    <li className="data-items">
                        <span className="cen-num">{detail.move_total}</span>
                        <span>转名额 ></span>
                    </li>
                    <li className="data-items">
                        <span className="cen-num">{detail.total_apply_count}</span>
                        <span>申请 ></span>
                    </li>
                    {/* 数据面板整块未改造：微信内直接拉起小程序，非微信冒泡到 ul 弹二维码面板 */}
                    {this.renderMiniCover()}
                </ul>
                <Button className='cancel-btn' onClick={()=>{
                    this.props.close()                 
                }}>取消</Button>
            </Modal>
        )
    }
}

export default ManageDialog;
